

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


/*
	Vue.js
*/


import Vue from "vue"
import App from "./App"

Vue.config.productionTip = false


/*
	Vuex
*/


import vuex from "vuex"

Vue.use(vuex)


/*
	Router
*/


import router from "./router"

Vue.router = router


/*
	Image Viewer
*/


/*import Viewer from "v-viewer";

Vue.use(Viewer, {
	defaultOptions: {
		title: false,
		toolbar: false,
		zIndex: 9999
	}
});*/


/*
	Axios
*/


import VueAxios from "vue-axios"
import axios from "axios"

Vue.use(VueAxios, axios)

axios.defaults.baseURL = "http://localhost/compass-api/public/api"

if (process.env.NODE_ENV == "production") {
	axios.defaults.baseURL = "https://compass.vertogroup.com.au/laravel/public/api";
}


/*
	Auth
*/


Vue.use(require("@websanova/vue-auth"), {
	auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
	http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
	router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
	//rolesVar: "permissions",
	//tokenExpired: false,
});


/*
	UI
*/


import ElementUI from "element-ui";

import { Message, Notification } from "element-ui";

import "element-ui/lib/theme-chalk/index.css";

import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });


/*
	CSS
*/


import "./assets/base.scss";
import "./assets/css/checklists.scss";
import "./assets/css/comment-box.scss";
import "./assets/css/comment.scss";
import "./assets/css/filter-bar.scss";
import "./assets/css/text-editor.scss";
import "./assets/css/history.scss";


/*
	Google Maps
*/


import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
	load: { key: "AIzaSyA32-sh4lSHPstYyn649HkVnZjzTl20iNQ" }
});


/*
	JSON Excel
*/


import JsonExcel from "vue-json-excel";
 
Vue.component("downloadExcel", JsonExcel);


/*
	Custom Filters
*/


Vue.filter("isDescriptionBlank", function(value) {
	if (value && typeof value == "string") {
		return ["", "<p></p>"].includes(value.trim());
	}
	return true;
});

Vue.filter("timebookSummary", function(value) {
	
	let days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;
	
	total_seconds = parseInt(Math.floor(value / 1000));
	total_minutes = parseInt(Math.floor(total_seconds / 60));
	total_hours = parseInt(Math.floor(total_minutes / 60));
	days = parseInt(Math.floor(total_hours / 24));
	
	seconds = parseInt(total_seconds % 60);
	minutes = parseInt(total_minutes % 60);
	hours = parseInt(total_hours % 24);
	
	seconds = (seconds < 10) ? "0" + seconds : seconds;
	minutes = (minutes < 10) ? "0" + minutes : minutes;
	hours = (hours < 10) ? "0" + hours : hours;
	days = (days < 10) ? "0" + days : days;
	
	return `${total_hours} hours, ${minutes} minutes, ${seconds} seconds`;
	
});

Vue.filter("formatMilliseconds", function(value, format) {
	
	let days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;
	
	total_seconds = parseInt(Math.floor(value / 1000));
	total_minutes = parseInt(Math.floor(total_seconds / 60));
	total_hours = parseInt(Math.floor(total_minutes / 60));
	days = parseInt(Math.floor(total_hours / 24));
	
	seconds = parseInt(total_seconds % 60);
	minutes = parseInt(total_minutes % 60);
	hours = parseInt(total_hours % 24);
	
	seconds = (seconds < 10) ? "0" + seconds : seconds;
	minutes = (minutes < 10) ? "0" + minutes : minutes;
	hours = (hours < 10) ? "0" + hours : hours;
	days = (days < 10) ? "0" + days : days;
	
	switch(format) {
		case 's':
			return total_seconds;
			break;
		case 'm':
			return total_minutes;
			break;
		case 'h':
			return total_hours;
			break;
		case 'd':
			return days;
			break;
		default:
			return `${days}d:${hours}h:${minutes}m:${seconds}s`;
			//return { d: days, h: hours, m: minutes, s: seconds };
	}
	
});

Vue.filter("formatCurrency", function(value) {
	
    if (typeof value !== "number") {
        return value;
    }
	
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0
    });
	
    return formatter.format(value);
	
});

Vue.filter("dateFormatted", function(value) {
	return new Date(value).toDateString();
});

Vue.filter("commentTimestamp", function(value) {
	return new Date(value).toLocaleString("en-AU").toUpperCase();
});

Vue.filter("timeString", function(value) {
	
	var sec_num = parseInt(value);
	var hours   = Math.floor(sec_num / 3600);
	var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
	var seconds = sec_num - (hours * 3600) - (minutes * 60);
	
	if (hours < 10) { hours = "0" + hours; }
	if (minutes < 10) { minutes = "0" + minutes; }
	if (seconds < 10) { seconds = "0" + seconds; }
	
	return hours + "h:" + minutes + "m:" + seconds + "s";
	
});

/*
	Custom Directives
*/

import linkify from "vue-linkify";

Vue.directive("linkify", linkify);

Vue.directive("tag-users", {
	
	bind: function(el, binding) {
		
		console.log(el, binding);
		console.log(el.innerHTML);
		
		var name = "Simon Burford";
		
		var newHTML = el.innerHTML.replace("Simon Burford", "<Tag>123</Tag>");
		
		
		
		//console.log(el.innerHTML.replace("Simon Burford", "<span>123</span>"));
		
		el.innerHTML = newHTML;
		
		//console.log(el.innerHTML.indexOf(name));
		
	},
	
	inserted: function (el, binding) {
		console.log(el, binding);
	}
	
})

/*
	State
*/


const store = new vuex.Store({
	
	state: {
		
		theTime: new Date().getTime(),
		
		loggedIn: false,
		
		// Clients
		
		clients: [],
		
		clientSlug: "",
		
		//selectedClientId: null,
		
		// Projects
		
		projects: [],
		
		projectSlug: "",
		
		// Tickets
		
		selectedTicketId: null,
		
		//selectedTicket: {},
		
		// Time Book
		
		
		
		// Users
		
		users: [],
		
		//usersState: "add",
		
		//selectedUserId: null,
		
		// Tickets
		
		ticketTypes: [ "Development / Feature", "Scoping / Documentation", "Tech Support", "Bug", "Research", "Training", "Other" ],
		ticketStatuses: [ "Pending", "Approved", "Rejected", "In Progress", "Completed", "Finalised" ],
		
		platforms: [ "Android", "iPhone", "iPad", "Web", "Desktop" ],
		
		includedInPlanTypes: ["Tech Support", "Bug"],
		
		
		
		// Settings
		
		loading: false,
		
		/*settings: {
			confirmDeleteComment: true,
		},*/
		
		timebook: {
			
			recording: false,
			timer: 0,
			
			seconds: 0,
			minutes: 0,
			hours: 0,
			
			client_id: null,
			project_id: null,
			ticket_id: null,
			
			ticket: {},
			
			project_name: "",
			
			description: "",
			
		},
		
		timebookEntries: [],
		
	},
	
	getters: {
		
		theTime(state) {
			return state.theTime;
		},
		
		loggedIn(state) {
			return state.loggedIn;
		},
		
		uploadURL(state) {
			return `${axios.defaults.baseURL}/image`;
		},
		
		loading(state) {
			return state.loading;
		},
		
		timebookTicket(state, getters) {
			if (state.timebook.ticket.hasOwnProperty("id")) {
				return state.timebook.ticket;
			}
			return {};
		},
		
		timebookEntries(state, getters) {
			return state.timebookEntries;
		},
		
		/*
			Get Selected Client
		*/
		
		client: (state, getters) => {
			return state.clients.find((c) => c.slug === getters.clientSlug) || {};
		},
		
		clientId(state, getters) {
			return getters.client.id;
		},
		
		clientSlug(state, getters) {
			return state.clientSlug;
		},
		
		clientIndex(state, getters) {
			return state.clients.findIndex((c) => {
				return c.slug === state.clientSlug;
			});
			//return clients.findIndex((p) => p.slug === projectSlug) || null;
		},
		
		/*
			Get Selected Project
		*/
		
		project(state, getters) {
			return state.projects.find((p) => p.slug === getters.projectSlug) || {};
		},
		
		projectId(state, getters) {
			return getters.project.id;
		},
		
		projectSlug(state, getters) {
			return state.projectSlug;
		},
		
		projectIndex(state, getters) {
			return state.projects.findIndex((p) => {
				return p.slug === state.projectSlug;
			});
			//return projects.findIndex((p) => p.slug === projectSlug) || null;
		},
		
		/*
			Get Selected Ticket
		*/
		
		selectedTicket(state, getters) {
			if (getters.project.hasOwnProperty("id")) {
				return getters.project.tickets.find((t) => t.public_id === getters.selectedTicketId) || {};
			}
			return {};
		},
		
		selectedTicketId(state, getters) {
			return state.selectedTicketId;
		},
		
		selectedTicketIndex(state, getters) {
			if (getters.project.hasOwnProperty("id")) {
				return getters.project.tickets.findIndex((t) => {
					return t.public_id === getters.selectedTicketId;
				});
			}
			return null;
		},
		
	},
	
	mutations: {
		
		theTime(state) {
			state.theTime = new Date().getTime();
		},
		
		loggedIn(state, loggedIn) {
			state.loggedIn = loggedIn;
		},
		
		setApiData(state, params) {
			state[params.key] = params.data;
		},
		
		setClientSlug(state, clientSlug) {
			state.clientSlug = clientSlug;
		},
		
		setProjectSlug(state, projectSlug) {
			state.projectSlug = projectSlug;
		},
		
		setSelectedTicketId(state, selectedTicketId) {
			state.selectedTicketId = selectedTicketId;
		},
		
		setTimebookEntries(state, timebookEntries) {
			state.timebookEntries = timebookEntries;
		},
		
		/*setUsersState(state, usersState) {
			state.usersState = usersState;
		},*/
		
		stopTimeBookRecording(state, params) {
			
			// Reset properties.
			
			clearInterval(state.timebook.timer);
			
			// Stopping or starting recording?
			
			if (state.timebook.recording == true) {
				
				// Not recording!
				
				state.timebook.recording = false;
				
				// Log timebook entry.
				
				axios.post("timebook", {
					
					client_id: state.timebook.client_id,
					project_id: state.timebook.project_id,
					ticket_id: state.timebook.ticket_id,
					
					description: state.timebook.description ? state.timebook.description : "Automatic entry",
					duration: state.timebook.seconds * 1000,
					
					manual: 0,
					
					user_id: params.user_id,
					
				}).then(function(response) {
					
					// Success!
					
					Notification.success({
						title: "Success!",
						message: "Your time has been logged.",
					});
					
					// Reset time book recording.
					
					state.timebook.hours = 0;
					state.timebook.minutes = 0;
					state.timebook.seconds = 0;
					
					state.timebook.client_id = null;
					state.timebook.project_id = null;
					state.timebook.ticket_id = null;
					
					state.timebook.ticket = {};
					
					state.timebook.project_name = "";
					
					state.timebook.description = "";
					
					// Callback?
					
					if (params.callback) {
						params.callback({
							state: "success",
						});
					}
					
				}).catch(function(e) {
					
					// Error!
					
					Notification.error({
						title: "Uh oh!",
						message: "An unknown error occurred while logging your time.",
						duration: 5000,
					});
					
					// Reset time book recording.
					
					state.timebook.hours = 0;
					state.timebook.minutes = 0;
					state.timebook.seconds = 0;
					
					state.timebook.client_id = null;
					state.timebook.project_id = null;
					state.timebook.ticket_id = null;
					
					state.timebook.ticket = {};
					
					state.timebook.project_name = "";
					
					state.timebook.description = "";
					
					// Callback?
					
					if (params.callback) {
						params.callback({
							state: "error",
						});
					}
					
				});
				
			} else {
				
				// Callback?
				
				if (params.callback) {
					params.callback();
				}
				
			}
			
		},
		
		toggleTimeBookRecording(state, params) {
			
			// Reset properties.
			
			clearInterval(state.timebook.timer);
			
			// Update propreties.
			
			state.timebook.client_id = params.client_id;
			state.timebook.project_id = params.project_id;
			state.timebook.ticket_id = params.ticket_id;
			
			state.timebook.ticket = params.ticket;
			
			state.timebook.project_name = params.project_name ? params.project_name : "";
			
			// Stopping or starting recording?
			
			//console.log("toggleTimeBookRecording", state, params);
			
			if (state.timebook.recording == true) {
				
				// Not recording!
				
				state.timebook.recording = false;
				
				// Log timebook entry.
				
				axios.post("timebook", {
					
					client_id: state.timebook.client_id,
					project_id: state.timebook.project_id,
					ticket_id: state.timebook.ticket_id,
					
					description: state.timebook.description ? state.timebook.description : "Automatic entry",
					duration: state.timebook.seconds * 1000,
					
					manual: 0,
					
					user_id: params.user_id,
					
				}).then(function(response) {
					
					// Success!
					
					Notification.success({
						title: "Success!",
						message: "Your time has been logged.",
					});
					
					// Reset time book recording.
					
					state.timebook.hours = 0;
					state.timebook.minutes = 0;
					state.timebook.seconds = 0;
					
					state.timebook.client_id = null;
					state.timebook.project_id = null;
					state.timebook.ticket_id = null;
					
					state.timebook.ticket = {};
					
					state.timebook.project_name = "";
					
					state.timebook.description = "";
					
					// Callback?
					
					if (params.callback) {
						params.callback({
							state: "success",
						});
					}
					
				}).catch(function(e) {
					
					// Error!
					
					Notification.error({
						title: "Uh oh!",
						message: "An unknown error occurred while logging your time.",
						duration: 5000,
					});
					
					// Reset time book recording.
					
					state.timebook.hours = 0;
					state.timebook.minutes = 0;
					state.timebook.seconds = 0;
					
					state.timebook.client_id = null;
					state.timebook.project_id = null;
					state.timebook.ticket_id = null;
					
					state.timebook.ticket = {};
					
					state.timebook.project_name = "";
					
					state.timebook.description = "";
					
					// Callback?
					
					if (params.callback) {
						params.callback({
							state: "error",
						});
					}
					
				});
				
			} else if (state.timebook.recording == false) {
				
				// Recording!
				
				state.timebook.recording = true;
				
				// Update propreties.
				
				/*state.timebook.client_id = params.client_id;
				state.timebook.project_id = params.project_id;
				state.timebook.ticket_id = params.ticket_id;
				
				state.timebook.ticket = params.ticket;
				
				state.timebook.project_name = params.project_name ? params.project_name : "";
				*/
				// Start timer.
				
				state.timebook.timer = setInterval(function() {
					state.timebook.hours = Math.floor(state.timebook.seconds / 3600);
					state.timebook.minutes = Math.floor((state.timebook.seconds - (state.timebook.hours * 3600)) / 60);
					state.timebook.seconds += 1;
				}, 1000);
				
				// Callback?
				
				if (params.callback) {
					params.callback({
						state: "start",
					});
				}
				
			}
			
		},
		
		setLoading(state, params) {
			if (params.type == "start") {
				state.loading = true;
				//iView.LoadingBar.start();
			} else if (params.type == "finish") {
				state.loading = false;
				//iView.LoadingBar.finish();
				if (params.message) {
					Notification.success({
						title: "Success!",
						message: params.message,
					});
				}
			} else if (params.type == "error") {
				state.loading = false;
				//iView.LoadingBar.error();
				if (params.message) {
					Notification.error({
						title: "Uh oh!",
						message: params.message,
						duration: 5000,
					});
				}
			}
		},
		
	},
	
	actions: {
		
		refreshSelectedTicket(store, params) {
			
			store.commit("setSelectedTicketId", params.id);
			
			store.commit("setLoading", { type: "start" });
			
			axios.get(`tickets/${params.id}`).then((r) => {
				if (r.data.length) {
					store.commit("setLoading", { type: "finish" });
					store.dispatch("updateSelectedTicket", r.data[0]);
				} else {
					store.commit("setLoading", { type: "error" });
				}
				if (params.callback) {
					params.callback(r.data.length > 0);
				}
			}).catch((e) => {
				store.commit("setLoading", { type: "error" });
			});
			
		},
		
		refreshSelectedProject(store, params, callback) {
			
			if (params.hasOwnProperty("data")) {
				
				store.dispatch("updateSelectedProject", params.data);
				
			} else {
				
				store.commit("setProjectSlug", params.slug);
				
				store.commit("setLoading", { type: "start" });
				
				axios.get(`projects/${params.slug}`).then((r) => {
					if (r.data.length) {
						store.commit("setLoading", { type: "finish" });
						store.dispatch("updateSelectedProject", r.data[0]);
					} else {
						store.commit("setLoading", { type: "error" });
					}
					if (params.callback) {
						params.callback(r.data.length > 0);
					}
				}).catch((e) => {
					store.commit("setLoading", { type: "error" });
				});
				
			}
			
		},
		
		refreshSelectedClient(store, params, callback) {
			
			if (params.hasOwnProperty("data")) {
				
				store.dispatch("updateSelectedClient", params.data);
				
			} else {
				
				store.commit("setClientSlug", params.slug);
				
				store.commit("setLoading", { type: "start" });
				
				axios.get(`clients/${params.slug}`).then((r) => {
					if (r.data.length) {
						store.commit("setLoading", { type: "finish" });
						store.dispatch("updateSelectedClient", r.data[0]);
					} else {
						store.commit("setLoading", { type: "error" });
					}
					if (params.callback) {
						params.callback(r.data.length > 0);
					}
				}).catch((e) => {
					store.commit("setLoading", { type: "error" });
				});
				
			}
			
		},
		
		updateSelectedTicket(store, newData) {
			Vue.set(store.state.projects[store.getters.projectIndex].tickets, store.getters.selectedTicketIndex, newData);
		},
		
		updateSelectedProjectTickets(store, newData) {
			Vue.set(store.state.projects[store.getters.projectIndex], "tickets", newData);
		},
		
		updateSelectedProject(store, newData) {
			Vue.set(store.state.projects, store.getters.projectIndex, newData);
		},
		
		updateSelectedClient(store, newData) {
			Vue.set(store.state.clients, store.getters.clientIndex, newData);
		},
		
		getTimebookEntries(store, params) {
			
			/*axios.get("timebook").then((r) => {
				
			}).catch((e) => {
				
			});*/
			
		},
		
		getApiData(store, params) {
			
			store.commit("setLoading", {type: "start"});
			
			axios.get(params.key).then(response => {
				
				if (response.status == 200) {
					
					store.commit("setLoading", {type: "finish"});
					
					store.commit("setApiData", {
						key: params.key,
						data: response.data,
					}, response.data);
					
				} else {
					
					store.commit("setLoading", {type: "error"});
					
				}
				
			}).catch(e => {
				
				store.commit("setLoading", {type: "error"});
				
			});
			
		},
		
	},
	
})


/*
	Load App
*/


new Vue({
	el: "#app",
	router,
	store,
	components: { App },
	template: "<App/>"
});




// WEBPACK FOOTER //
// ./src/main.js